/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useCallback, useMemo, useState, useEffect} from 'react'
import {saveAs} from 'file-saver'
import * as XLSX from 'xlsx'
import Papa from 'papaparse'
import {KTSVG, useDebounce} from '../../../helpers'
import {listLevelResult} from '../../../../api/levelResultApi'
import {listSimulation} from '../../../../api/simulationApi'
import {listSessionVR} from '../../../../api/sessionVRApi'
import Select from 'react-select'
import {ViewDetailsLevelResult} from '../../modals/view-details-level-result/ViewDetailsLevelResult'
import {DeleteLevelResult} from '../../modals/delete-level-result/DeleteLevelResult'
import {ExportRisultati} from './Esportatori/EsportaRisultati'
import {UsersListSearchComponent} from '../../../../app/modules/apps/user-management/users-list/components/header/UsersListSearchComponent'
import {UsersListPagination} from '../../../../app/modules/apps/user-management/users-list/components/pagination/UsersListPagination'
import { useAuth } from '../../../../app/modules/auth/core/Auth'

import './StoricoRisultatiWidget.css';

import dayjs from 'dayjs';
import 'dayjs/locale/it';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);
dayjs.locale('it');

interface MyData {
  Nome_discente: string
  Cognome_discente: string
  ID_Risultato_livello: number
  Livello: string
  Punteggio: string
  Simulazione: string
  Data_risultato: string
  ID_Sessione_VR: string
}

type SortConfig = {
  key: keyof MyData;
  direction: 'asc' | 'desc';
};

type Props = {
  className: string
}

interface SelectedOption {
  value: string;
  label: string;
}

const StoricoRisultatiWidget: React.FC<Props> = ({className}) => {
  const {currentUser, logout} = useAuth()
  const user = currentUser as any;

  const [data, setData] = useState<MyData[]>([]);
  const [allData, setAllData] = useState<MyData[]>([]);
  const [filteredData, setFilteredData] = useState<MyData[]>([]); // New state for filtered data
  const [searchTerm, setSearchTerm] = useState<string>(''); // New state for search term
  const debouncedSearchTerm = useDebounce(searchTerm, 150); // Debounce search term
  const [sortConfig, setSortConfig] = useState<SortConfig>({ key: 'Punteggio', direction: 'desc' });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Numero di elementi per pagina

  const start = (currentPage - 1) * itemsPerPage;
  const end = start + itemsPerPage;

  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRecordId, setSelectedRecordId] = useState<number | null>(null);
  const [typeSimulation, setTypeSimulation] = useState<string>('');
  const [typeSessionVR, setTypeSessionVR] = useState<string>(''); // Nuovo stato per il filtro codice sessione VR
  const [sessionVRList, setSessionVRList] = useState<any[]>([]); // Stato per memorizzare la lista delle sessioni VR

  const [showExportModal, setShowExportModal] = useState(false)
  const [exportSimulation, setExportSimulation] = useState('Tutte')
  const [exportSessionVR, setExportSessionVR] = useState('Tutte')


  const [simulationList, setSimulationList] = useState<any[]>([]);

  const calcolaPunteggio = (quiz:any) => {
    if (!quiz) return null;
  
    let punteggio = 0;
    let totaleDomande = 0;
    try {
      const data = quiz;
      data.domande.forEach((domanda:any) => {
        totaleDomande++;
        const userAnswer = domanda.risposte.filter((risposta:any) => risposta.sceltaUtente);
        if (userAnswer.length === 1 && userAnswer[0].corretta) {
          punteggio++;
        }
      });
    } catch (error) {
      console.error("Errore nel parsing del JSON:", error);
      return null;
    }
    return `${punteggio}/${totaleDomande}`;
  };

  /* Se il punteggio a sinistra dello slash supera il massimo a destra, lo tronca al valore massimo.
  Esempio: 20/18  →  18/18 */
  const fixScore = (score: string | null): string | null => {
    if (!score) return score          // gestisci null / stringa vuota
    const [rawCorrect, rawTotal] = score.split('/').map(Number)

    // se il parsing fallisce lascio il valore com’è
    if (Number.isNaN(rawCorrect) || Number.isNaN(rawTotal)) return score

    const correct = Math.min(rawCorrect, rawTotal) // tronco se serve
    return `${correct}/${rawTotal}`
  }

  /*const getPercentage = (scoreStr: string | null): number => {
    if (!scoreStr) return 0;
    const [correct, total] = scoreStr.split('/').map(s => Number(s));
    return total > 0 ? (correct / total) * 100 : 0;
  };*/

  const sortedData = useMemo(() => {
    return [...filteredData].sort((a, b) => {
      // Verifica se la chiave è "Numero" e converti i valori in numeri prima di confrontarli
      if (sortConfig.key === 'ID_Risultato_livello') {
        const aValue = Number(a.ID_Risultato_livello) || 0; // Usa 0 se il Numero non può essere convertito in un numero
        const bValue = Number(b.ID_Risultato_livello) || 0; // Usa 0 se il Numero non può essere convertito in un numero
        return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue;
      } 
      // nuovo caso per Punteggio
      if (sortConfig.key === 'Punteggio') {
        // 1) estrai numeratore e denominatore
        const [aCorrect, aTotal] = (a.Punteggio || '0/0').split('/').map(Number);
        const [bCorrect, bTotal] = (b.Punteggio || '0/0').split('/').map(Number);

        // 2) calcola le percentuali
        const aPct = aTotal > 0 ? (aCorrect / aTotal) * 100 : 0;
        const bPct = bTotal > 0 ? (bCorrect / bTotal) * 100 : 0;

        // 3) confronto principale su percentuale
        if (aPct !== bPct) {
          return sortConfig.direction === 'asc'
            ? aPct - bPct
            : bPct - aPct;
        }

        // 4) tie-breaker: su “correct answers” (più alto prima, o viceversa)
        return sortConfig.direction === 'asc'
          ? aCorrect - bCorrect
          : bCorrect - aCorrect;
      }
      // resto dei campi (stringhe)
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }, [filteredData, sortConfig]);

  const handleRowClick = (action: string, recordId: number) => {
    setSelectedRecordId(recordId);
    if(action === 'view-details') {
      setShowModal(true);
    } else if(action === 'delete-levelresult') {
      setShowDeleteModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleDeleteCloseModal = () => {
    setShowDeleteModal(false);
  };


  const fetchData = useCallback(async () => {
    try {
      let response = await listLevelResult(user.ID_User);

      //Casto le date da formato americano a italiano
      for (let i = 0; i < response.length; i++) {
        let Data_risultato_US = dayjs(response[i].Data_risultato);
        response[i].Data_risultato = Data_risultato_US.format('DD/MM/YYYY');

        // Calcola punteggio se Livello è "Didattica"
        if ((response[i].Livello === "Didattica" || response[i].Livello === "Quiz") && response[i].Punteggio === null) {
          response[i].Punteggio = calcolaPunteggio(response[i].Risultato_quiz);
        }

        response[i].Punteggio = fixScore(response[i].Punteggio)
      }

      // salva TUTTI i dati prima del filtro
      setAllData(response);

      // Filtro in base a `typeSimulation`, se è stato selezionato
      if (typeSimulation && typeSimulation !== '') {
        response = response.filter((item: MyData) => String(item.Simulazione) === typeSimulation);
      }   

      if (typeSessionVR && typeSessionVR !== '') {
        response = response.filter((item: MyData) => String(item.ID_Sessione_VR) === typeSessionVR);
      }

      // Imposta i dati
      setData(response);
    } catch (error) {
      console.error(error);
    }
  }, [typeSimulation, typeSessionVR]);

  useEffect(() => {
    fetchData();
  }, [fetchData, typeSimulation, typeSessionVR]);

  // useEffect per gestire la barra di ricerca
  useEffect(() => {
    if (debouncedSearchTerm) {
      const lowerCasedSearchTerm = debouncedSearchTerm.toLowerCase();
      const filtered = data.filter(goggle => {
        return Object.values(goggle).some(val => {
          if (val !== null && typeof val === 'string') {
            return val.toLowerCase().includes(lowerCasedSearchTerm);
          }
          return false;
        });
      });
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, [debouncedSearchTerm, data]);

  useEffect(() => {
    const fetchSimulazioni = async () => {
      try {
        const response = await listSimulation();

        // Filtra solo le simulazioni con Tipologia "Singleplayer"
        const filteredSimulazioni = response.filter((simulazione: any) => simulazione.Tipologia === 'Singleplayer');
        
        setSimulationList(filteredSimulazioni);
      } catch (error) {
        console.error('Errore nel recupero delle simulazioni:', error);
      }
    };
    fetchSimulazioni();
  }, []);

  useEffect(() => {
    const fetchSessioniVR = async () => {
      try {
        const response = await listSessionVR(user.ID_User);
        setSessionVRList(response);
      } catch (error) {
        console.error('Errore nel recupero delle sessioni VR:', error);
      }
    };
    fetchSessioniVR();
  }, []);

  const simulationOptions = useMemo(() => {
    return [...simulationList]
      .sort((a, b) => String(a.Titolo).localeCompare(String(b.Titolo), 'it', { sensitivity: 'base' }))
      .map(s => ({
        value: s.Titolo,
        label: s.Titolo
      }))
  }, [simulationList])
  
  const sessionOptions = useMemo(() => {
    return [...sessionVRList]
      .sort((a, b) => String(a.ID_Sessione_VR).localeCompare(String(b.ID_Sessione_VR), 'it', { sensitivity: 'base' }))
      .map(s => ({
        value: s.ID_Sessione_VR,
        label: s.ID_Sessione_VR
      }))
  }, [sessionVRList])
  
  const changeSort = (key: keyof MyData) => {
    setSortConfig(currentSortConfig => {
      if (currentSortConfig.key === key) {
        return { key, direction: currentSortConfig.direction === 'asc' ? 'desc' : 'asc' };
      }
      return { key, direction: 'asc' };
    });
  };

  /*const exportDataToCSV = () => {
    const csv = Papa.unparse(filteredData);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'Data.csv');
  };*/

  const exportDataToXLSX = () => {
    let dataToExport = allData;
  
    if (exportSimulation !== 'Tutte') {
      dataToExport = dataToExport.filter(d => d.Simulazione === exportSimulation)
    }
  
    if (exportSessionVR !== 'Tutte') {
      dataToExport = dataToExport.filter(d => d.ID_Sessione_VR === exportSessionVR)
    }
  
    const headers = ([
      { key: 'Nome_discente', label: 'NOME' },
      { key: 'Cognome_discente', label: 'COGNOME' },
      { key: 'Simulazione', label: 'SIMULAZIONE' },
      { key: 'Livello', label: 'LIVELLO' },
      { key: 'Punteggio', label: 'PUNTEGGIO' },
      { key: 'Data_risultato', label: 'DATA' },
      { key: 'ID_Sessione_VR', label: 'SESSIONE VR' },
    ] as { key: keyof MyData; label: string }[]);
  
    const sheetData = dataToExport.map(row =>
      headers.reduce((acc, h) => {
        let value = row[h.key as keyof MyData]
  
        if (h.key === 'Data_risultato' && typeof value === 'string') {
          const parsed = dayjs(value, 'DD/MM/YYYY', true)
          acc[h.label] = parsed.isValid() ? parsed.toDate() : value
        } else {
          acc[h.label] = value ?? '-'
        }
  
        return acc
      }, {} as Record<string, any>)
    )
  
    const ws = XLSX.utils.json_to_sheet(sheetData, {
      header: headers.map(h => h.label),
      dateNF: 'dd/mm/yyyy',
    })
  
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Risultati')
  
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const blob = new Blob([wbout], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
  
    saveAs(blob, `Risultati.xlsx`)
  }

  const handleSimulationChange = (selectedOption: SelectedOption | null) => {
    if (selectedOption) {
      setTypeSimulation(selectedOption.value);
    } else {
      // Gestisci il caso in cui non vi sia alcuna selezione
      // Ad esempio, potresti voler resettare il filtro o gestire questo caso in altro modo
      setTypeSimulation(''); // O un altro valore di default appropriato
    }
  };

  const handleSessionVRChange = (selectedOption: SelectedOption | null) => {
    if (selectedOption) {
      setTypeSessionVR(selectedOption.value);
    } else {
      setTypeSessionVR(''); // Resetta il filtro se nessuna opzione è selezionata
    }
  };
  
  return (
    <div className={`card ${className}`}>
      {/* begin::Barra ricerca */}
      <div className='card-header border-0 pt-6'>
      <UsersListSearchComponent setParentSearchTerm={setSearchTerm} />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Total Goggles */}
        <div className='me-10'>
          <span className='fw-bold'></span>
        </div>
        {/* end::Total Goggles */}
        {/* begin::Export */}
        <button type='button' className='btn btn-light-primary me-3 no-margin' onClick={() => setShowExportModal(true)}>
          <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
          Export
        </button>
        {/* end::Export */}
      </div>
      {/* end::Card toolbar */}
      </div>
      {/* end::Barra ricerca */}
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Storico risultati - Individuale</span>
          <span className='text-muted mt-1 fw-semibold fs-7'></span>
        </h3>
        <div className='card-toolbar'>
          <Select
            className='form-select-solid form-select-lg fw-bold select-z-index'
            options={[
              { value: '', label: 'TUTTE LE SESSIONI VR' },
              ...[...sessionVRList]
                .sort((a, b) =>
                  String(a.ID_Sessione_VR).localeCompare(String(b.ID_Sessione_VR), 'it', { sensitivity: 'base' })
                )
                .map((session) => ({
                  value: session.ID_Sessione_VR,
                  label: session.ID_Sessione_VR
                }))
            ]}
            isSearchable={false}
            onChange={handleSessionVRChange}
            placeholder="TUTTE LE SESSIONI VR"
          />
          <Select
              className='form-select-solid form-select-lg fw-bold select-z-index'
              options={[
                { value: '', label: 'TUTTE LE SIMULAZIONI' },
                ...[...simulationList]
                  .sort((a, b) =>
                    String(a.Titolo).localeCompare(String(b.Titolo), 'it', { sensitivity: 'base' })
                  )
                  .map((simulazione) => ({
                    value: simulazione.Titolo,
                    label: simulazione.Titolo
                  }))
              ]}
              isSearchable={false}
              onChange={handleSimulationChange}
              placeholder= "TUTTE LE SIMULAZIONI"
          />
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        <div className='tab-content'>
          {/* begin::Tap pane */}
          <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
            {/* begin::Table container */}
            <div className='table-responsive'>
              {/* begin::Table */}
              <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                {/* begin::Table head */}
                <thead>
                  <tr className='border-0'>
                    <th className='p-0 w-1px'></th>
                    <th className='p-0 min-w-130px th-padding text-muted fw-bold text-head' onClick={() => changeSort('Nome_discente')}>Nome</th>
                    <th className='p-0 min-w-130px th-padding text-muted fw-bold text-head' onClick={() => changeSort('Cognome_discente')}>Cognome</th>
                    <th className='p-0 min-w-130px th-padding text-muted fw-bold text-head' onClick={() => changeSort('Simulazione')}>Simulazione</th>
                    <th className='p-0 min-w-150px th-padding text-muted fw-bold text-head' onClick={() => changeSort('Livello')}>Livello</th>
                    <th
                      className='p-0 min-w-50px th-padding text-muted fw-bold text-head'
                      onClick={() => changeSort('Punteggio')}
                    >
                      <div className="d-flex align-items-center">
                        Punteggio
                        {sortConfig.key === 'Punteggio' && (
                          <KTSVG
                            path={
                              sortConfig.direction === 'asc'
                              ? '/media/icons/duotune/arrows/arr065.svg'  // freccia su
                              : '/media/icons/duotune/arrows/arr066.svg'  // freccia giù
                            }
                            className="svg-icon-3 ms-2"
                          />
                        )}
                      </div>
                    </th>
                    <th className='p-0 min-w-50px th-padding text-muted fw-bold text-head' onClick={() => changeSort('Data_risultato')}>Data</th>
                    <th className='p-0 min-w-50px th-padding text-muted fw-bold text-head' onClick={() => changeSort('ID_Sessione_VR')}>Sessione VR</th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody>
                {sortedData.slice(start, end).map(item => (
                    <tr key={item.ID_Risultato_livello}>
                      <td></td>
                      <td style={{ fontSize: "1.15rem" }} className='fw-semibold'>{item.Nome_discente === null ? "-" : item.Nome_discente}</td> 
                      <td style={{ fontSize: "1.15rem" }} className='fw-semibold'>{item.Cognome_discente === null ? "-" : item.Cognome_discente}</td>
                      <td className='text-body fw-semibold'>{item.Simulazione === null ? "-" : item.Simulazione}</td> 
                      <td className='text-body fw-semibold'>{item.Livello === null ? "-" : item.Livello}</td>
                      <td className='text-body fw-semibold'>{item.Punteggio === null ? "-" : item.Punteggio}</td>
                      <td className='text-body fw-semibold'>{item.Data_risultato === "Invalid Date" ? "-" : item.Data_risultato}</td>
                      <td className='text-body fw-semibold'>{item.ID_Sessione_VR === null ? "-" : item.ID_Sessione_VR}</td> 
                      <td className='text-body fw-semibold text-end'>
                        <div className='btn-group'>
                          <button
                            className='btn btn-icon btn-light-primary'
                            onClick={() => handleRowClick('delete-levelresult', item.ID_Risultato_livello)}
                          >
                            <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-2' />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
                {/* end::Table body */}
              </table>
            </div>
            {/* end::Table */}
            <div className='pagination-z-index'>
              <UsersListPagination
                totalItems={filteredData.length}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                onPageChange={setCurrentPage}
              />
            </div>
          </div>
          {/* end::Tap pane */}

        </div>
      </div>
      {/* end::Body */}
      <ExportRisultati
        show={showExportModal}
        onClose={() => setShowExportModal(false)}
        exportSimulation={exportSimulation}
        setExportSimulation={setExportSimulation}
        exportSessionVR={exportSessionVR}
        setExportSessionVR={setExportSessionVR}
        simulations={simulationOptions}
        sessions={sessionOptions}
        onExport={exportDataToXLSX}
      />
      {selectedRecordId !== null && (
        <>
        <DeleteLevelResult show={showDeleteModal} handleClose={handleDeleteCloseModal} recordId={selectedRecordId}/>
        </>
      )}
    </div>
  )
}

export {StoricoRisultatiWidget}